{
    "header": {},
    "footer": {},
    "page": {
        "select-device": {
            "fluidnc": "Воспользуйтесь этой опцией, если хотите установить, обновить или настроить контроллер Arabesque.",
            "continue": "Продолжить выполнение"
        },
        "connection": {
            "title": "Установщик Arabesque",
            "description": "Этот инструмент упростит установку или обновление Arabesque на контроллере. Подключите контроллер и нажмите Подключиться, чтобы продолжить.",
            "connect": "Подключено",
            "connecting": "Подключение",
            "establishing-connection": "Установка соединения с контроллером"
        },
        "home": {
            "description": "Теперь вы подключены к устройству, пожалуйста, выберите действие ниже",
            "error-while-booting": "Произошла ошибка во время загрузки, скорее всего из-за неправильной конфигурации.",
            "show-details": "Нажмите здесь, чтобы увидеть подробности"
        },
        "file-browser": {
            "title": "Файловый менеджер",
            "loading": "Загрузка...",
            "downloading": "Скачивание...",
            "uploading": "Выгрузка",
            "config-missing": "Конфигурационный файл \"{{configFilename}}\" отсутствует, хотите его создать?",
            "create-config": "Создать конфигурацию",
            "create-new-config": "Создать новую конфигурацию",
            "upload": "Загрузить",
            "active-config": "Активная конфигурация",
            "select-config": "Выбрать конфигурацию",
            "select-as-config": "Выбрать как конфигурацию",
            "edit": "Редактировать",
            "delete": "Удалить",
            "download": "Скачать"
        },
        "terminal": {
            "title": "Терминал",
            "restarting": "Перезапуск контроллера...",
            "restart": "Перезапустить",
            "restart-description": "Сделать жесткий сброс на контроллере, установив DTR/RTS",
            "reset": "Сброс",
            "reset-description": "Сброс контроллера командой 0x18",
            "unlock": "Разблокировать",
            "unlock-description": "Разблокировать контроллер $X",
            "status": "Статус",
            "status-description": "Получить состояние контроллера",
            "startup": "Стартовое сообщение",
            "startup-description": "Получать сообщения в журнале запуска",
            "version": "Версия",
            "version-description": "Получить версию прошивки"
        },
        "not-found": {
            "title": "Страница не найдена",
            "go-back-home": "Возвращение домой"
        }
    },
    "panel": {
        "navigation": {
            "home": "Начальная страница",
            "install": "Установка",
            "terminal": "Терминал",
            "file-browser": "Файловый менеджер",
            "wifi": "Wi-Fi",
            "calibrate": "Калибровка",
            "stacktrace-decoder": "Декодировать трассировку стека",
            "restart": "Перезагрузка",
            "disconnect": "Отключиться"
        },
        "firmware": {
            "install": "Установка",
            "install-description": "Выберите прошивку, которую вы хотите установить на контроллер.",
            "loading": "Загрузка...",
            "install-custom-image": "Установить собственное изображение...",
            "show-prereleases": "Показывать предварительные версии",
            "fetching": "Обработка"
        },
        "progress": {
            "title": "Устанавливается",
            "downloading": "Загрузка пакета...",
            "validating": "Проверка изображения...",
            "flashing": "Установка пакета на устройство..."
        },
        "bootloader": {
            "waiting": "Ожидание ввода контроллера в режим загрузки...",
            "not-active": "Загрузчик не активен - удерживайте клавишу BOOT"
        },
        "unsupported": {
            "title": "Браузер не поддерживается",
            "description": "Ваш текущий веб-браузер не поддерживается, пожалуйста, используйте Chrome, Edge или Opera"
        }
    },
    "component": {
        "log": {
            "show-details": "Показать подробности",
            "hide-details": "Скрыть подробности"
        }
    },
    "modal": {
        "installer": {
            "error-reconnecting": "Произошла ошибка при пере подключении, пожалуйста, перезагрузите контроллер",
            "uploading": "Загружается",
            "downloading": "Скачивание",
            "downloading-description": "Скачивание пакета...",
            "restarting": "Перезапуск",
            "restarting-description": "Ожидание перезапуска контроллера...",
            "uploading-files": "Загрузка файлов",
            "uploading-files-description": "Загрузка файлов...",
            "done": "Готово",
            "done-description": "Контроллер успешно установлен и готов к использованию.",
            "continue": "Продолжить выполнение",
            "error": "Ошибка!",
            "close": "Закрыть",
            "confirm-installation": "Подтвердите установку",
            "confirm-installation-description": "Установка прошивки \"{{release}}\" на контроллер. Данные будут удалены {{not}}.",
            "not": "нет",
            "installation-speed": "Скорость установки",
            "installation-speed-help": "Некоторые контроллеры должны быть установлены на меньшую скорость. Если вы испытываете проблемы, вы можете попробовать уменьшить скорость.",
            "install": "Установить",
            "cancel": "Отмена",
            "select-image": "Выбрать изображение",
            "select-image-description1": "Если вы скачали пакет вручную, вы можете прошить образ отсюда.",
            "select-image-description2": "Выберите файл firmware.bin для прошивки контроллера.",
            "select-image-button": "Выберите картинку прошивки"
        },
        "lost-connection": {
            "description": "Потеряно соединение с контроллером",
            "close": "Закрыть"
        }
    },
    "card": {
        "install": {
            "upgrade-description": "Обновите Arabesque с помощью",
            "install-description": "На этот контроллер, похоже, не установлен Arabesque, хотите его установить?",
            "upgrade-button": "Обновить Arabesque",
            "install-button": "Установить Arabesque"
        },
        "terminal": {
            "open-terminal": "Открыть терминал",
            "open-terminal-description": "Открыть последовательный терминал к контроллеру"
        },
        "file-browser": {
            "open-browser": "Файловый менеджер",
            "open-browser-description": "Управление файлами на контроллере"
        },
        "calibrate": {
            "calibrate": "Калибровка",
            "calibrate-description": "Калибровка параметров на контроллере"
        },
        "wifi": {
            "configure": "Настройка WiFi",
            "configure-description": "Управление настройками WiFi контроллера",
            "connected-to": "Подключение к",
            "access-point": "Точка доступа"
        },
        "stacktrace": {
            "open": "Декодировать трассировку стека",
            "description": "Декодируйте следы стека ESP32 с помощью файлов addrinfo"
        }
    }
}
